import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/tree_start_150.png'
import _imports_1 from '@/assets/upload_tree.png'


const _withScopeId = n => (_pushScopeId("data-v-3443f450"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-tree-page" }
const _hoisted_2 = { class: "page-content container-lg" }
const _hoisted_3 = { class: "build-section" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode(" Start your tree ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "instructions" }, [
  /*#__PURE__*/_createTextVNode(" Start your family tree by using a "),
  /*#__PURE__*/_createElementVNode("strong", null, "genealogy app"),
  /*#__PURE__*/_createTextVNode(" and entering what you know. Then use "),
  /*#__PURE__*/_createElementVNode("strong", null, "online records"),
  /*#__PURE__*/_createTextVNode(" to find out more. Many popular apps and websites can help you get started. ")
], -1))
const _hoisted_6 = { class: "row main-content" }
const _hoisted_7 = { class: "col-md-6 apps-area" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Genealogy apps"),
  /*#__PURE__*/_createElementVNode("h5", null, "Use one of these to start building your family tree")
], -1))
const _hoisted_9 = { class: "list-unstyled app-list" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other-apps" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-inline btn-link btn-sm",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#otherAppsHelp",
    "aria-expanded": "false",
    "aria-controls": "moreApps"
  }, " Can I use a different app? "),
  /*#__PURE__*/_createElementVNode("div", {
    id: "otherAppsHelp",
    class: "collapse"
  }, " If you use one of these apps, you can share your tree directly on Tree Crossing without exporting from the app. We're working on support for other apps, too. ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_14 = { class: "col-md-6 records-area" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Online records", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Use these to find out more about your ancestors", -1))
const _hoisted_17 = { class: "list-unstyled records-list" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "site-name" }
const _hoisted_21 = { class: "site-desc" }
const _hoisted_22 = { class: "share-section" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Share what you find", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "instructions" }, [
  /*#__PURE__*/_createTextVNode(" As soon as you have something to share, come back and we'll help you share "),
  /*#__PURE__*/_createElementVNode("strong", null, "your"),
  /*#__PURE__*/_createTextVNode(" family tree online! ")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "laptop with tree"
}, null, -1))

import { computed } from 'vue'
import { workspaceTypeInfos } from '@/rd/ResearchDataModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateTreePage',
  setup(__props) {

const promoteApps = ['RootsMagic', 'Legacy', 'AncestralQuest', 'FamilyTreeMaker']

const appsRef = computed(() => workspaceTypeInfos.filter(t => promoteApps.includes(t.id)))
const recordSites = [
  {
    id: 'FamilySearch',
    name: 'FamilySearch',
    url: 'https://www.familysearch.org',
    icon: new URL('@/assets/logos/FamilySearch.png', import.meta.url).href,
    desc: 'Records from the United States, Canada, Europe, Latin America, and more',
  },
  {
    id: 'Ancestry',
    name: 'Ancestry',
    url: 'https://www.ancestry.com',
    icon: new URL('@/assets/logos/Ancestry.png', import.meta.url).href,
    desc: 'Records from the United States, Canada, Europe, Australia and more',
  },
  {
    id: 'MyHeritage',
    name: 'MyHeritage',
    url: 'https://www.myheritage.com',
    icon: new URL('@/assets/logos/MyHeritage.png', import.meta.url).href,
    desc: 'Records from Central and Eastern Europe, Scandinavia, Middle East, and more',
  },
  {
    id: 'AmericanAncestors',
    name: 'American Ancestors',
    url: 'https://www.americanancestors.org',
    icon: new URL('@/assets/logos/AmericanAncestors.png', import.meta.url).href,
    desc: 'Records from the United States, British Isles, continental Europe, and more',
  },
  {
    id: 'FindMyPast',
    name: 'FindMyPast',
    url: 'https://www.findmypast.com',
    icon: new URL('@/assets/logos/Findmypast.png', import.meta.url).href,
    desc: 'Records from the UK, Ireland, Australia, and former British colonies',
  },
]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appsRef.value, (app) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: app.id
                }, [
                  _createElementVNode("a", {
                    href: app.infoUrl,
                    class: "link-dark",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, [
                    _createElementVNode("img", {
                      src: app.icon,
                      alt: app.product
                    }, null, 8, _hoisted_11),
                    _createElementVNode("div", null, _toDisplayString(app.product), 1)
                  ], 8, _hoisted_10)
                ]))
              }), 128))
            ]),
            _hoisted_12,
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("ul", _hoisted_17, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(recordSites, (site) => {
                return _createElementVNode("li", {
                  key: site.id
                }, [
                  _createElementVNode("a", {
                    href: site.url,
                    class: "link-dark",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, [
                    _createElementVNode("img", {
                      src: site.icon,
                      alt: site.name
                    }, null, 8, _hoisted_19),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(site.name), 1),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(site.desc), 1)
                    ])
                  ], 8, _hoisted_18)
                ])
              }), 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_22, [
        _hoisted_23,
        _hoisted_24,
        _hoisted_25,
        _createVNode(_component_router_link, {
          class: "btn btn-primary",
          to: "/signup"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Upload my tree")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})